const { useEffect } = require('react');
import platform from 'platform';

export const usePlatform = () => {
  useEffect(() => {}, []);
  const isIos = platform.os && platform.os.family === 'iOS';
  const isSafari = platform.name === "Safari";
  return {
    isIos,
    isSafari
  };
};
